import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import validator from 'validator';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Api } from '../../../smoothr-web-app-core/api/api';
import { Gender } from 'src/smoothr-web-app-core/enums/Gender';

import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthStrategy } from '../../../smoothr-web-app-core/models/AuthStrategy';
import { axiosErrorToMessage } from '../../../smoothr-web-app-core/utils/utils';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { IonInput, ModalController } from '@ionic/angular';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { countries } from 'src/app/components/input-phone-with-county-code/mock-countries';
import { Company } from 'src/smoothr-web-app-core/models/CompanyCode';
import { AppComponent } from 'src/app/app.component';
import { InfoModalComponent } from '../info-modal/info-modal.component';

@Component({
	selector: 'app-user-data-modal',
	templateUrl: './user-data-modal.component.html',
	styleUrls: ['user-data-modal.component.scss'],
})
export class UserDataModalComponent implements OnInit {
	public isAccount = true;
	showRePassword = false;
	showPassword = false;
	isValidEmail = true;
	isValidName = true;
	isValidPassword = true;
	isValidRePassword = true;
	venue: Venue;
	// fullName = 'fullName';
	name: string = 'name';
	surname: string = 'surname';
	phone = 'phone';
	day = 'day';
	month = 'month';
	year = 'year';
	dnd_codeInvalid = false;
	loading = false;

	signUpForm: FormGroup;

	private readonly subscription: Subscription;

	constructor(
		private translate: TranslateService,
		private router: Router,
		private repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private fb: FormBuilder,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {
		// if (repository.customer && !repository.customer.isAnonymous) {
		//   this.navigationService.account();
		// }
	}
	static async show(modalCtrl: ModalController): Promise<void> {
		const modal = await modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'sign-modal' : 'menu-modal',
			component: UserDataModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		this.createFormSignUp();
	}

	createFormSignUp() {
		const formControlNames: any = {};
		// formControlNames[this.fullName] = ['', [Validators.required, Validators.pattern(/\w+\s\w+/)]];
		formControlNames[this.name] = ['', [Validators.required]];
		formControlNames[this.surname] = ['', [Validators.required]];
		formControlNames[this.phone] = ['', [this._customPhoneValidatorForLibrary]];
		formControlNames[this.day] = ['', [Validators.max(31)]];
		formControlNames[this.month] = ['', [Validators.max(12)]];
		formControlNames[this.year] = ['', [Validators.min(1900)]];
		this.signUpForm = this.fb.group(formControlNames);
		this.patchForm();
	}
	private patchForm() {
		let defaultPhone = {
			country: '+41',
			phone: '',
		};

		if (this.repository && this.repository?.customer && this.repository?.customer?.phone) {
			let countryCode = countries.find(it => this.repository.customer?.phone?.trim().startsWith('+' + it.dialCode));
			defaultPhone = {
				country: '+' + (countryCode?.dialCode || '41'),
				phone: this.repository.customer?.phone
					? this.repository.customer?.phone?.trim()?.replace('+' + countryCode?.dialCode, '')
					: '',
			};
		}

		if (this.isAccount && this.repository.customer) {
			this.signUpForm.patchValue(
				{
					gender: this.repository.customer.gender,
					// fullName: this.repository.customer.name,
					name: this.repository.customer.name.split(/[ _]+/)[0] ?? '',
					surname: this.repository.customer.name.split(/[ _]+/)[1] ?? '',
					email: this.repository.customer.email,

					phone: {
						country: defaultPhone.country,
						phone: defaultPhone.phone,
					},
				},
				{ emitEvent: true }
			);
			if (this.repository.customer.birthDate) {
				this.signUpForm.patchValue({
					day: new Date(this.repository.customer.birthDate).getDate(),
					month: new Date(this.repository.customer.birthDate).getMonth() + 1,
					year: new Date(this.repository.customer.birthDate).getFullYear(),
				});
			}
		}
	}
	private _isPasswordMatch(): ValidatorFn {
		return () => {
			const pass = this.signUpForm?.get('password')?.value;
			const confirmPass = this.signUpForm?.get('rePassword')?.value;
			return pass === confirmPass ? null : { notSame: true };
		};
	}
	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + control?.value?.phone.toString());
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.hasError('required') && this.signUpForm.get(controlName)?.touched;
		}

		return this.signUpForm.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.errors && !this.signUpForm.get(controlName)?.hasError('required');
		}
		return this.signUpForm.invalid;
	}

	getControlValue(controlName?: string) {
		if (controlName) {
			return this.signUpForm?.get(controlName)?.value;
		}
		return '';
	}

	ngOnDestroy() {
		if (this.subscription && !this.subscription.closed) {
			this.subscription.unsubscribe();
		}
	}
	async update() {
		try {
			this.loading = true;

			const response = await Api.patchCustomer({
				...this.repository.customer,
				// name: this.getControlValue('fullName'),
				name: this.getControlValue('name') + ' ' + this.getControlValue('surname'),
				preferredVenues: [],
				phone:
					this.getControlValue('phone')?.phone && this.getControlValue('phone')?.country
						? this.getControlValue('phone')?.country + this.getControlValue('phone')?.phone
						: null,
				birthDate:
					this.getControlValue(this.year) && this.getControlValue(this.month) && this.getControlValue(this.day)
						? new Date(
								new Date(0).setFullYear(
									this.getControlValue(this.year),
									Number(this.getControlValue(this.month)) - 1,
									this.getControlValue(this.day)
								)
							).toString()
						: null,
			});

			const mainUser = this.repository._customerAuth;
			mainUser.customer = { ...mainUser.customer, ...response.data };
			this.repository.customerAuth.next(mainUser);
			this.loading = false;
			this.snackbarCtrl.open('Your account was updated', null, {
				duration: 4000,
			});
			this.modalCtrl.dismiss();
		} catch (e) {
			console.log(e);
			this.loading = false;

			if (e?.response?.data?.message) {
				this.snackbarCtrl.open(e.response.data.message, null, {
					duration: 4000,
				});
			} else {
				this.snackbarCtrl.open(this.translate.instant('account.error'), null, {
					duration: 2000,
				});
			}
		}
	}

	setEmailValid() {
		this.isValidEmail = true;
	}

	setNameValid() {
		this.isValidName = true;
	}

	setPasswordValid() {
		this.isValidPassword = true;
		this.isValidRePassword = true;
	}

	goBack() {
		if (this.repository._order === null) {
			this.navigationService.home();
		} else {
			this.navigationService.menu();
		}
	}
	gotoNextField(nextElement: IonInput) {
		nextElement.setFocus();
	}
	getErrorsForm(controlName) {
		if (controlName) {
			return this.signUpForm.get('phone').errors;
		}
		return null;
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	async deleteAccount() {
		const result = await InfoModalComponent.show(this.modalCtrl, {
			title: this.translate.instant('account.delete_account.header'),
			info: this.translate.instant('account.delete_account.msg'),
			mainButton: this.translate.instant('account.delete_account.yes'),
			closeButton: this.translate.instant('account.delete_account.no'),
		});
		if (result && this.repository?._customerAuth && this.repository?._customerAuth?.customer) {
			try {
				await Api.deleteAccount();
				this.snackbarCtrl.open(this.translate.instant('account.delete_account.success'), null, {
					duration: 3000,
				});
				this.repository.customerAuth.next(null);
				this.modalCtrl.dismiss();
			} catch (e) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('account.delete_account.error'), null, {
					duration: 3000,
				});
			}
		}
		console.log(result);
	}
}
